export const SET_LANG = 'SET_LANG'
export const SET_CUR_MSG = 'setCurMsg'